<template>
  <div id >
    <h1>我的帳戶</h1><!--目前所在頁面標題-->
    <section class="panel">
      <div class="avatarWrapper cf">
        <div class="avatar">
          <div class="photo">
            <img :src="userInfo.avatar">
          </div>
          <!--上傳功能-->
          <!-- <div class="avatarPicker">
              <input class="inputfile" title="上傳照片" type="file" @change="onFileChanged" id="profile_pic" name="profile_pic" accept=".jpg, .jpeg, .png">
              <label for="profile_pic">Choose a file</label>
          </div> -->
          <!--上傳功能 end-->
        </div>
        <div class="info">
          <div class="wrap">
            <strong v-if="userInfo.nickname !=null">{{userInfo.nickname}}</strong>
            <strong v-else-if="userInfo.email !=null">{{userInfo.email}}</strong>
            <strong v-else>{{userInfo.sns_account}}</strong>
            <p>
              <b class="others" v-if="userInfo.type == 1">Facebook  登入</b>
              <b class="others" v-if="userInfo.type == 2">Google  登入</b>
              <b class="others" v-if="userInfo.type == 3">手機號碼登入</b>
              <b class="others" v-if="userInfo.type == 4">udn 會員登入</b>
              <b class="others" v-if="userInfo.type == 5">Device 登入</b>
            </p>
          </div>
        </div>
      </div>
      <div class="wallet cf">
        <h3>錢包餘額</h3>
        <strong>{{userInfo.points}}點</strong>
      </div>
    </section>
    <section class="panel userSetting">
      <h2>個人資料</h2>
      <label for="nickname" class="inp"><!--如果輸入錯誤 新增class "error"-->
        <input  type="text" id="nickname" placeholder=" " v-model="nickName">

        <span class="label">暱稱</span>
        <span class="border"></span>
        <span class="errorText">此電子信箱不存在</span><!--輸入錯誤時出現-->
      </label>
      <div class="list_info">
        <h4>ID</h4>
        <p>{{userInfo.account}}</p>
      </div>
      <button @click="changeCredentials" type="submit" class="btnStyle_2" id="submit_login_udn">
        <span data-original-title="儲存">儲存</span>
      </button>
    </section>
    <button @click="signOut" type="submit" class="btnStyle_2 colorWhite" id="submit_login_udn">
      <span data-original-title="登出">登出</span>
    </button>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { mapGetters } from 'vuex'
import { getPersonalDataForPatch } from '@/assets/js/api/api.js'
// import { getPersonalData } from '@/assets/js/api/api.js'

export default {
  name: 'async',
  metaInfo () {
    return {

      title: '我的帳戶 | 我的 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '我的帳戶 | 我的 | 一刻鯨選' },
        { property: 'og:site_name', content: '我的帳戶 | 我的 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '登入後，即可查看帳戶所有資訊。' }

      ]
    }
  },
  data () {
    return {
      nickName: '',
      token: '',
      user: '',
      userImg: ''

    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    if (this.userInfo.nickname != null) {
      this.nickName = this.userInfo.nickname
    } else if (this.userInfo.email != null) {
      this.nickName = this.userInfo.email
    } else {
      this.nickName = this.userInfo.sns_account
    }
  },

  methods: {
    onFileChanged (event) {
      const that = this

      var f = event.target.files[0] // FileList object
      var reader = new FileReader()
      // Closure to capture the file information.
      reader.onload = (function (theFile) {
        return function (e) {
          var binaryData = e.target.result
          // Converting Binary Data to base 64
          var base64String = window.btoa(binaryData)
          // showing file converted to base64
          that.userImg = base64String
        }
      })(f)
      // Read in the image file as a data URL.

      reader.readAsBinaryString(f)
    },
    signOut () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch('authLogout').then(() => {
            this.$router.push('/')
            this.$store.commit('savePath', '/index')
          })
          localStorage.removeItem('user-info')
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    async changeCredentials () {
      this.token = await getPersonalDataForPatch(this.nickName, this.userImg, ` ${localStorage.getItem('credentialToken')}`)
      this.getUser(this.token.data.data)
    },

    async getUser (credentialToken) {
      var params = {
        CiphertextBlob: this.base64ToArrayBuffer(credentialToken)
      }
      // 12.解密 個人加密資料
      const tempUserData = await this.kmsDecrypt(params)
      localStorage.setItem('user-info', tempUserData)
      const userInfo = JSON.parse(tempUserData)
      this.validated = 0
      if (userInfo.avatar == null) {
        userInfo.avatar = '@/assets/images/globalMember_icon.png'
      }
      this.$store.commit('changeUserInfo', userInfo)
      location.reload()
    },
    base64ToArrayBuffer (base64) {
      // eslint-disable-next-line camelcase
      var binary_string = window.atob(base64)
      var len = binary_string.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i)
      }
      return bytes.buffer
    },
    kmsDecrypt (params) {
      return new Promise((s, j) => {
        const kmsClient = new AWS.KMS() // kmsTool
        kmsClient.decrypt(params, (err, data) => {
          if (err) j(err)
          else {
            const { Plaintext } = data
            const token = String.fromCharCode(...Plaintext)
            s(token)
          }
        })
      })
    }

    // changeCredentials(){
    //     alert(this.nickName);
    //        this.axios.patch(
    //            this.$store.getters.baseURL + 'credentials',
    //            {'nickname':this.nickname},
    //            { headers: {  'Content-Type': 'application/json',"Authorization" : `Bearer ${localStorage.getItem('credentialToken')}`} }
    //            ).then(response => {
    //            // localStorage.setItem("credentialToken", response.data);
    //             this.token = response.data.data;
    //             this.getUser(this.token);
    //           //  localStorage.setItem("credentialToken", this.token);
    //             })
    //   .catch(error => console.log("log:"+error));

    // },
    //  getUser(credentialToken) {
    //      console.log("credentialToken:"+credentialToken);
    //     this.axios.get(
    //            this.$store.getters.baseURL + 'credentials',
    //           { headers: {"Authorization" : `Bearer ${localStorage.getItem('credentialToken')}`} }
    //            ).then(response => {
    //               this.user = response;

    //             })
    //   .catch(error => console.log("log:"+error));

    // }
  }
}
</script>

<style>
@import '../../../assets/css/user.css';
@import '../../../assets/css/user_rwd.css';
 body {padding-top: 0;}

/* body {padding-top: 0;}
.bodyHeader {display: none;} */

/* body {padding-top: 128;}
.bodyHeader {display: none;} */
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyProfile.vue